export class BaseOrderItemCreationDto {
  constructor(data) {
    this.package_id = data.package_id;
    this.qty = data.qty;
  }
}

export class OrderItemCreationDto extends BaseOrderItemCreationDto {
  constructor(data) {
    super(data);

    this.discount_custom_amount = data.discount_custom_amount;
    this.discount_code = data.discount_code;
    this.remember_class_id = data.remember_class_id;
    this.remember_exam_language_id = data.remember_exam_language_id;
  }
}

export class OrderItemUpdateDto extends OrderItemCreationDto {}
